import React, { useState, useEffect, useRef } from "react";
import classNames from "classnames";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import { getOverallSettingsClasses, componentId, mobileIs } from "../../utils/siteUtils";
import { BackgroundImage, PrimaryButton } from "../../elements";
import "./style.scss";
import { gtag } from "../../utils";
const ProductSpecs = props => {
    const { rendering, fields, page } = props;
    const {
        pc_title, pc_subtitle, m_title, m_subtitle, pc_image, m_image, list
    } = fields;
    const isMobile = mobileIs()
    const rootClasses = classNames("c-product-specs", getOverallSettingsClasses(fields));
    const rootId = componentId(rendering);
    return (
        <div className={rootClasses} datasourceid={rendering.dataSource} id={rootId}>
            <div className="c-product-specs__header">
                <RichText tag="div" className="title" field={isMobile ? m_title : pc_title} />
                <RichText tag="div" className="subtitle" field={isMobile ? m_subtitle : pc_subtitle} />
            </div>
            <div className="c-product-specs__background">
                <BackgroundImage {...(isMobile ? m_image : pc_image)} className="c-product-specs__bg-image" />
            </div>
            <div className="c-product-specs__content">
                {list?.map((listItem, index) => (
                    <div className="c-product-specs__category" key={index}>
                        <RichText tag="div" className="category-title" field={listItem?.fields?.title} />
                        <div className="category-list">
                            {listItem?.fields?.specsList?.map((item, index) => (
                                <RichText
                                    tag="div"
                                    className="category-item-text"
                                    field={item?.fields?.text}
                                    key={index}
                                />
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ProductSpecs;